var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgForwardArrowGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33325 9.1651V10.8318H13.3333L8.74992 15.4151L9.93325 16.5984L16.5333 9.99844L9.93325 3.39844L8.74992 4.58177L13.3333 9.1651H3.33325Z",
    fill: "#849E47"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForwardArrowGreen);
export default __webpack_public_path__ + "static/media/forward_arrow_green.5c0d2aff7382e07a016823d8c846ef1c.svg";
export { ForwardRef as ReactComponent };